import { useFromAssets, useToAssets } from '../context/assets.js';
const useIsExchangeLoading = () => {
    const { loading: loadingFromAssets } = useFromAssets();
    const { loading: loadingToAssets } = useToAssets();
    return loadingFromAssets || loadingToAssets;
};
export default useIsExchangeLoading;
